/*       */

import { label, placeholder, name } from 'app/utils/designer/form/settings/common/commonBase';
import { multiple, filterBy, excludeBy, orderBy } from 'app/utils/designer/form/settings/common/commonGeneral';
import { onLoad, onChange, isVisible, isDisabled } from 'app/utils/designer/form/settings/common/commonEvents';
import { help } from 'app/utils/designer/form/settings/common/commonHelpers';
import { flexGrow } from 'app/utils/designer/form/settings/common/commonStyles';
import { required, classRequired, readOnly } from 'app/utils/designer/form/settings/common/commonValidation';

export default {
    defaults: {
        serialize: true,
        fromType: null,
        toType: null,
        withDefault: true
    },
    panels: settingsValues => {
       
        return [
            {
                header: 'Base',
                children: [
                    name,
                    label,
                    placeholder,
                    {
                        type: 'entityTypesTypeahead',
                        properties: {
                            label: 'Entity type',
                            name: 'properties.fromType',
                            valueField: 'uri',
                        },
                    
                    },
                    {
                        type: 'entityTypesTypeahead',
                        properties: {
                            label: 'Related entity type',
                            name: 'properties.toType',
                            valueField: 'uri',
                        },
                  
                    },
                ],
            },
            {
                header: 'General',
                children: [multiple, filterBy, excludeBy, orderBy],
            },
            {
                header: 'Events',
                children: [onLoad, onChange, isVisible, settingsValues?.viewType !== 'class' && isDisabled].filter(Boolean),
            },
            {
                header: 'Validation',
                children: [ 
                    settingsValues?.viewType !== 'class' ? required : classRequired,
                    settingsValues?.viewType === 'class' && readOnly,
                ].filter(Boolean),
            },
            {
                header: 'Styles',
                children: [flexGrow],
            },
            {
                header: 'Helpers',
                children: [help],
            },
        ].filter(Boolean);
    },
};
